//TODO: Fix PDF path
//
export default {
    configPath: "./config.json",
    bonusPath: "json/document_symlinks.json",
    chartPath: "json/charts",
    examPath: "json/charts/exams",
    treePath: "json/structure.json",
    searchPrintPath: "json/search_print.json",
    claimPath: "json/claims.json"
};
